<template>
  <div class="modal fade bs-example-modal-sm" id="subscribe" tabindex="-1" role="dialog" aria-labelledby="myModalLabel1">
    <div class="modal-dialog modal-sm">
      <div class="modal-content" id="myModalLabel1">
        <div class="modal-header">
              <h4 class="modal-title">{{ $t('subscribe.title') }}</h4>
          </div>
        <div class="modal-body">
          <!-- Tab panels -->
          <div class="tab-content">
            <!-- Employer Panel 1-->
            <div class="tab-pane fade in show active">
              <div class="row mrg-bot-20">
                <div class="col-md-12">
                  <p>{{ $t('subscribe.tips') }}</p>
                  <img v-if="isVisible" height="262" :src="url" style="margin: 0px 0px 0px -10px" />
                </div>
              </div>
        
            </div>
            <!--/.Panel 1-->
          </div>
          <!-- Tab panels -->
        </div>
      </div>
    </div>
  </div>  
</template>
<script>
/* global $ */

export default {
  name: 'SubscribeModal',
  data() {
    return {
      isVisible: false
    }
  },
  computed: {
    url: function() {
      let rn = parseInt((Math.random() + 1) * Math.pow(10, 9))
      return this.API_PREFIX + '/api/wechat/subscribe_qr?id=' + rn + '&timeout=720&action=subscribe'
    }
  },
  mounted() {
    $('#subscribe').on('shown.bs.modal', () => {
      this.isVisible = true
    }).on('hidden.bs.modal', () => {
      this.isVisible = false
    })
  }
}
</script>